<template>
  <modal :show="show" @change="$emit('change',$event)" width="400">
      <template v-slot:header>
        <span class="fs-22">Внимание!</span>
      </template>
      <template v-slot:main>
        <div class="modal-content">
          <div class="tes-text modal-content-text">
            До окончания срока <br>поверки прибора учета <br> осталось
            <span class="red--text">{{date}}</span>
          </div>
        </div>
    </template>
  </modal>
</template>

<script>
import Modal from "../common/Modal";

export default {
  name: "ModalReadingsInfo",
  components: { Modal },
  model: {
    prop: "show",
    event: "change"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
        date: {
      type: String,
      default: ""
    }
  },
  computed: {},
  methods: {},
  created() {},
  watch: {}
};
</script>

<style lang="scss">
.modal-content-text {
  text-align: center;
  font-size: 20px;
  padding: 10px;
}
</style>